import { render, staticRenderFns } from "./GroupFolderNameChange.vue?vue&type=template&id=e7a11e54"
import script from "./GroupFolderNameChange.vue?vue&type=script&lang=js"
export * from "./GroupFolderNameChange.vue?vue&type=script&lang=js"
import style0 from "./GroupFolderNameChange.vue?vue&type=style&index=0&id=e7a11e54&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports